import { ConfigKeys } from './ConfigKeys'

export const ConfigTooltipTexts = {
  [ConfigKeys.ODKDY_JE_POZDE_OBJEDNANA_ASISTENCE_HODINY]:
    'Asistence je pozdě založená, když je založena nastavený počet hodin (a později) před začátkem týdne, ve kterém má probíhat. Např. při nastavení 48 hodin budou pozdě objednané všechny asistence na příští týden založené o víkendu.',
  [ConfigKeys.POZDE_OBJEDNANA_JESTLI_SE_VZTAHUJE_NA_KOORDINATORY]:
    'Při zaškrtnutí se bude parametr “Počet hodin před začátkem týdne, ve kterém asistence probíhá” vztahovat i na koordinátory.',
}

